import { connect } from 'react-redux';

import { getUserName, getWelcomeMessage } from 'app/modules';
import WelcomeMessage from 'presentation/components/WelcomeMessage';
import replaceUserName from 'lib/replaceUserName.js';

export const mapStateToProps = state => {
  return {
    welcomeMessage: composeWelcomeMessage(getUserName(state), getWelcomeMessage(state)),
  };
};

function composeWelcomeMessage(userName, welcomeMessage) {
  return replaceUserName(userName, welcomeMessage);
}

const WelcomeMessageContainer = connect(mapStateToProps)(WelcomeMessage);

export default WelcomeMessageContainer;
